import imgDarkDesktop from "../images/bg-desktop-dark.jpg";
import imgDarkMobile from "../images/bg-mobile-dark.jpg";
import imgLightDesktop from "../images/bg-desktop-light.jpg";
import imgLightMobile from "../images/bg-mobile-light.jpg";

export const lightTheme = {
  background: "hsl(0, 0%, 95%)",
  imgMobile: imgLightMobile,
  imgDesktop: imgLightDesktop,
  backgroundInput: "white",
  inputBorderBottom: "hsl(233, 11%, 84%)",
  footerColor: "hsl(236, 9%, 61%)",
  todoBackground: "white",
  todoTextColor: "hsl(235, 19%, 35%)",
  todoFinished: "hsl(234, 39%, 85%)",
  labelBackgroundColor: "white",
  labelBorder: "hsl(236, 33%, 92%)",
  closeButton: "hsl(236, 9%, 61%)",
  backgroundClearDiv: "white",
  backgroundClearDivColor: "hsl(236, 9%, 61%)",
  backgroundFilterDiv: "white",
  backgroundDesktopDiv: "white",
  buttonColor: "hsl(234, 11%, 52%)",
  buttonBackground: "white",
  desktopDivColor: "hsl(236, 9%, 61%)",
  filterButtons: "hsl(236, 9%, 61%)",
  buttonHover: "hsl(233, 14%, 35%)",
};
export const darkTheme = {
  background: "hsl(235, 21%, 11%)",
  imgMobile: imgDarkMobile,
  imgDesktop: imgDarkDesktop,
  backgroundInput: "hsl(235, 24%, 19%)",
  inputBorderBottom: "hsl(233, 14%, 35%)",
  footerColor: "hsl(234, 11%, 52%)",
  todoBackground: "hsl(235, 24%, 19%)",
  todoTextColor: "hsl(234, 39%, 85%)",
  todoFinished: "hsl(235, 19%, 35%)",
  labelBackgroundColor: "hsl(235, 24%, 19%)",
  labelBorder: "hsl(233, 14%, 35%)",
  closeButton: "hsl(233, 14%, 35%)",
  backgroundClearDiv: "hsl(235, 24%, 19%)",
  backgroundClearDivColor: "hsl(234, 11%, 52%)",
  backgroundFilterDiv: "hsl(235, 24%, 19%)",
  backgroundDesktopDiv: "hsl(235, 24%, 19%)",
  buttonColor: "hsl(234, 11%, 52%)",
  buttonBackground: "hsl(235, 24%, 19%)",
  desktopDivColor: "hsl(236, 9%, 61%)",
  filterButtons: "hsl(236, 9%, 61%)",
  buttonHover: "hsl(236, 33%, 92%)",
};
